const landingPage = {
  getPage: async () => {},
}

export default landingPage
